import script from "./ProcedureReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcedureReview.vue?vue&type=script&setup=true&lang=ts"

import "./ProcedureReview.vue?vue&type=style&index=0&id=31ecfd82&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31ecfd82"]])

export default __exports__